import { render, staticRenderFns } from "./PanelFilters.vue?vue&type=template&id=2463a619&scoped=true&"
import script from "./PanelFilters.vue?vue&type=script&lang=js&"
export * from "./PanelFilters.vue?vue&type=script&lang=js&"
import style0 from "./PanelFilters.vue?vue&type=style&index=0&id=2463a619&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2463a619",
  null
  
)

export default component.exports